import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { isOnlyMedia } from "~/components/bloks/ColumnsBlok/isOnlyMedia";
import type { ColumnsStoryblok } from "~/generated/sb/blok-types";
import styles from "./ColumnsBlok.module.css";

export const ColumnsBlok = ({ blok, preview }: BlokProps<ColumnsStoryblok>) => {
	const left = blok.left?.[0];
	const right = blok.right?.[0];

	/** we don't want to allow certain Y position combinations */
	const shouldOverrideY = (() => {
		if (!isOnlyMedia(left, right)) return false; // continue if we only have media components in both columns
		if (left?.position_y === right?.position_y) return true; // we don't allow equal Y positions - overriding
		return false;
	})();

	return (
		<BlokWrap
			editable={blok}
			className={clsx(styles.root, "columns-blok")}
			data-layout="blok"
			data-container="small"
		>
			<div className={styles.left}>
				{left && <StoryblokComponent blok={left} preview={preview} />}
			</div>
			<div className={clsx(styles.right, shouldOverrideY && styles.y_offset_override)}>
				{right && <StoryblokComponent blok={right} preview={preview} />}
			</div>
		</BlokWrap>
	);
};
